export enum EventCategoriesEnum {
  RENCONTRES = 'Rencontres',
  CAMPUS = 'Campus',
  ACCOMPAGNEMENT = 'Accompagnement',
  WEBINAR = 'Webinar',
  AUTRES = 'Autres'
}
